

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.shoppingcart', ['squid']).factory('$ShoppingCartModel', function ($Model, $Api) {
        return $Model.extend('$ShoppingCartModel', {
            api: new $Api({
                uri: '/api/shoppingcart/:id',
                postAttempts: 2,
                cache: true
            })
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/shoppingcart/index.js
// module id = ./components/xo-models/src/shoppingcart/index.js
// module chunks = 1